<!-- MENU DEFORMITY -->
<div class="box-menu-settings active">

	<div class="row-box">
		<h4>{{ labels().TOOLS_MENU_COMPONENT_DEFORMITY }}</h4>
		@if (isDeformityDone) { <div class="check-success ms-auto"></div> }
	</div>

	<div class="divider-box"></div>

	@if (stateType !== stateTypeEnum.deformityAnalysis) {
	<div data-testid="SUBSYS4_DEFMENU_ACTIVATE_BTN" class="row-box clickable" (click)="enableDeformity()"
		(keypress)="enableDeformity()">
		<i class="material-icons">more_horiz</i>
		<span>{{ labels().TOOLS_MENU_COMPONENT_ACTIVATE }}</span>
	</div>
	} @else {
	<div data-testid="SUBSYS4_DEFMENU_MECHAXIS_BTN" class="row-box clickable" (click)="setMechanicalAxis()"
		(keypress)="setMechanicalAxis()">
		<i class="material-icons">linear_scale</i>
		<span>{{ labels().TOOLS_MENU_COMPONENT_MECHANICAL_AXIS }}</span>
		@if (isDeformityDone) { <div class="check-success ms-auto"></div> }
	</div>
	<div data-testid="SUBSYS4_DEFMENU_CTRLAXIS_BTN" class="row-box" (click)="setContralateralAxis()"
		(keypress)="setContralateralAxis()" [class]="{'clickable': isCtrlEnabled, 'disabled': !isCtrlEnabled }">
		<i class="material-icons">add_circle</i>
		<span>{{ labels().TOOLS_MENU_COMPONENT_CONTRALATERAL_AXIS }}</span>
	</div>
	}

</div>